import React, { useEffect, useState } from "react";
import CircleSlider from "../Circle-Slider/Circle-Slider";
import AboutUsSection from "../About-Us-Section/AboutUs";
import "../../assets/css/homepageproduct.css";
import { useDispatch } from "react-redux";
import "../../assets/css/slider.css";
import "../../assets/css/custom.css";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { saveBanner, saveLandingCat, saveLogo, savelandingData } from "../../features/HomePageSlice/homeDataSlice";
import { GETURLDATA } from "../../assets/graphql";
import "react-tabs/style/react-tabs.css";
import "./Tabs.css"; // Import your custom styles
import ExcitingPage from "./ExcitingPage";
import { saveDirectUrlAccess } from "../../features/login/loginDataSlice";

const LandingPage = () => {
  const [categoreis, setCategoreis] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(saveDirectUrlAccess(true));
    const getURL = localStorage.getItem('loginURL');
    const currentUrl = window.location.href;
    const parts = currentUrl.split("/");
    console.log(parts, "parts")
    const value = parts[4] ? parts[4] : "default";
      if(getURL === value) {
        getDataOfURL(value ? value : "default");
      } else if(getURL === "login") {
        getDataOfURL(value ? value : "default");
      } else {
        getDataOfURL(getURL);
      }
    // console.log(value); // "aditya-birla"
  }, []);

  const getDataOfURL = async (value) => {
    const getURL = value;
    dispatch(dispatch(saveBanner("")));
    const result = await apiHandler({
      url: endpoint.GRAPHQL_URL,
      method: "POST",
      data: {
        base_url: endpoint.API_BASE_URL,
        variables: { getURL },
        query: GETURLDATA,
      },
    });
    if (!result.data.error_code) {
      setCategoreis(result.data.prelogin.categories);
      dispatch(dispatch(saveLandingCat(result.data.prelogin.categories)));
      dispatch(dispatch(saveBanner(result.data.prelogin.banners)));
      if(value === "default") {
        dispatch(saveLogo(""));
        dispatch(savelandingData(result.data.prelogin));
      } else {
        dispatch(saveLogo(result.data.prelogin.company[0].logo));
        dispatch(savelandingData(result.data.prelogin));
      }
      // dispatch(saveAccessories(result.data.products.items));
    }
  };
  
  return (
    <>
      <CircleSlider />
      {categoreis.length > 0 ? <ExcitingPage catData={categoreis} /> :   
        <section className="cat-tabs">
          <div className="col-xl-9 mx-auto text-center">
            <div className="landint-title">
              Site is loading..
            </div>
            
            <div className="container landint-title">
              Please wait
            </div>
          </div>
        </section>
        }
      
      <AboutUsSection />
    </>
  );
};

export default LandingPage;
